// overlayGate.mjs — "is something else about to take over the screen?"
//
// Some overlays open by themselves a moment after a page appears (the login
// consent prompt looks things up first, then opens). Anything optional that
// would also open by itself, such as the dashboard tour, has to wait for
// those to make up their mind: otherwise the two open on top of each other,
// or the optional one appears and is covered a second later.
//
// An overlay that may open on its own says so here while it is deciding and
// for as long as it is open. Whatever wants a clear screen waits for
// `overlaysClear()`.
//
// No imports and no browser APIs, so it runs under plain `node --test`.

const busy = new Set();
const listeners = new Set();

export function setOverlayBusy(key, isBusy) {
  const was = busy.has(key);
  if (isBusy) busy.add(key); else busy.delete(key);
  if (was !== busy.has(key)) [...listeners].forEach(fn => fn());
}

export function overlaysClear() {
  return busy.size === 0;
}

// Calls `fn` whenever an overlay starts or stops being busy. Returns the
// function that stops the calls.
export function onOverlaysChange(fn) {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
}
